// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"d00304f0","759":"f3daf72b"}[chunkId] + ".chunk.js";
};